import { CloseOutlined } from "@ant-design/icons";

type Props = {
  sidebarState: any[];
  sidebarWidth?: string;
  sidebarHeader?: React.ReactNode;
  sidebarTitle?: string;
  sidebarContent?: React.ReactNode;
  mainContent?: React.ReactNode;
  placement?: "left" | "right";
};

export default function CollapsibleSidebarLayout(props: Props) {
  const {
    sidebarWidth = "300px",
    sidebarHeader,
    sidebarTitle,
    sidebarContent,
    mainContent,
    sidebarState,
    placement = "left"
  } = props;
  const [isOpen, setIsOpen] = sidebarState;

  const isLeft = placement === "left";

  const getTransformClass = () => {
    if (isOpen) return "translate-x-0";
    return isLeft ? "-translate-x-full" : "translate-x-full";
  };

  const mainContentStyle = isLeft
    ? { marginLeft: isOpen ? sidebarWidth : "0" }
    : { marginRight: isOpen ? sidebarWidth : "0" };

  return (
    <div className="flex relative overflow-hidden h-full ">
      <div
        className={`
          absolute top-0 h-full 
          transition-transform duration-300 ease-in-out
          border-solid border-0 border-gray-200
          flex flex-col
          ${isLeft ? "left-0 border-r" : "right-0 border-l"}
          ${getTransformClass()}
        `}
        style={{ width: sidebarWidth }}
      >
        <div>
          {sidebarHeader ? (
            <div>{sidebarHeader}</div>
          ) : (
            <div className="flex items-center justify-between">
              <div className="font-bold text-sm p-4">{sidebarTitle}</div>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="border-none bg-transparent cursor-pointer p-2"
              >
                <CloseOutlined />
              </button>
            </div>
          )}
        </div>
        <div className="grow overflow-y-auto">{sidebarContent}</div>
      </div>

      <div
        className="transition-all duration-300 ease-in-out w-full overflow-auto"
        style={mainContentStyle}
      >
        {mainContent}
      </div>
    </div>
  );
}
